<template>
  <div class="invitations">
    <div v-if="this.$route.query.view" class="subHead">
      <van-icon name="arrow-left" class="arrow" @click="goBackMeeting" />
      <span class="subHead-text">预览</span>
    </div>
    <div class="whitePage">
      <div v-if="notFound">
        <div class="svgArea">
          <svg-icon icon-class="locked" class="none" />
        </div>
        <div class="back">
          <span @click="goBack">
            根据手机号未匹配到您的邀约记录
            <br>
            返回首页
          </span>
        </div>
      </div>
    </div>
    <blue
      v-if="pageStyle === 'blue'"
      ref="blue"
      :meeting-info="meetingInfo"
      :pass-info="passInfo"
      :data-form="dataForm"
      :upload-suc="uploadSuc"
      @meetingApply="meetingApply"
      @refreshQrCode="refreshQrCode"
      @onSign="onSign"
      @refreshUploadSuc="refreshUploadSuc"
      @onCancel="onCancel"
    />
    <green
      v-if="pageStyle === 'green'"
      ref="green"
      :meeting-info="meetingInfo"
      :pass-info="passInfo"
      :data-form="dataForm"
      :upload-suc="uploadSuc"
      @meetingApply="meetingApply"
      @refreshQrCode="refreshQrCode"
      @onSign="onSign"
      @refreshUploadSuc="refreshUploadSuc"
      @onCancel="onCancel"
    />
    <lightBlue
      v-if="pageStyle === 'lightBlue'"
      ref="lightBlue"
      :meeting-info="meetingInfo"
      :pass-info="passInfo"
      :data-form="dataForm"
      :upload-suc="uploadSuc"
      @meetingApply="meetingApply"
      @refreshQrCode="refreshQrCode"
      @onSign="onSign"
      @refreshUploadSuc="refreshUploadSuc"
      @onCancel="onCancel"
    />
    <van-dialog
      v-model="showCancelDialog"
      title="温馨提示"
      show-cancel-button
      @confirm="confirmCancel"
    >
      <van-cell-group>
        <van-field v-model="message" class="control" rows="1" autosize type="textarea" placeholder="请输入取消原因" />
      </van-cell-group>
    </van-dialog>
  </div>
</template>

<script>
import green from './green';
import blue from './blue';
import lightBlue from './lightBlue';
import { meetingInvitation, inviteApply, meetingSignIn, GetUserInfo, visitorCheck, meetingAttendeeCancel } from '@/api/user';
import { GetVisitorAppoinDetail, GetStaffInfo } from '@/api/user';
import config from '@/common/config';
import { onBind } from '@/api/home';

export default {
  name: 'Invitations',
  components: {
    lightBlue,
    blue,
    green
  },
  data() {
    return {
      baseURL: process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro,
      pageStyle: 'blue',
      meetingInfo: {
        agendasList: [],
        infoList: [],
        materials: []
      },
      message: '',
      uploadSuc: false,
      showCancelDialog: false,
      notFound: false,
      dataForm: {
        gender: 'MALE',
        meetingId: '',
        attendee: '',
        phone: '',
        validCode: '',
        company: '',
        carNumber: '',
        faceImg: ''
      },
      passInfo: {},
      personalInfo: {},
      login: false,
      statusMap: {
        FACE: '人脸识别',
        IC: ' IC卡',
        QR: '二维码',
        '': '无'
      }
    };
  },
  created() {
    this.wechatEve = true;
    this.pageStyle = this.$route.query.pageStyle;
    if (this.$route.query.view) {
      this.meetingInfo = JSON.parse(JSON.stringify(this.$store.state.submitForm));
      // if (this.$store.state.submitForm.visitorLogId) {
      //   this.getPassCode(this.$store.state.submitForm.visitorLogId);
      // }
      const { agendasList, materials } = this.$store.state.submitForm;
      this.meetingInfo.materials = materials;
      this.meetingInfo.meetingRoomName = this.$store.state.roomData.name;
      this.meetingInfo.meetingRoomLocation = this.$store.state.roomData.meetingRoomLocation;
      this.meetingInfo.agendasList = [];
      agendasList && agendasList.forEach((item, index) => {
        this.meetingInfo.agendasList.push(item.value);
      });
      this.meetingInfo.infoList = [
        { name: '会议时间', value: `${this.$store.state.submitForm.startTime} ~ ${this.$store.state.submitForm.endTime}` },
        { name: '会议地点', value: `${this.$store.state.submitForm.meetingRoomName}` },
        { name: '签到规则', value: `${this.$store.state.submitForm.ruleText}` },
        { name: '签到时间', value: `会议前${this.$store.state.submitForm.signTime || 0}分钟开始签到` }
        // { name: '会议资料', value: 'AI科技发布会新品抢先看.zip' }
      ];
    } else {
      const personalInfo = localStorage.getItem('personalInfo');
      this.login = !!personalInfo;
      if (personalInfo) {
        const info = JSON.parse(personalInfo);
        this.dataForm = {
          gender: info.gender || 'MALE',
          meetingId: '',
          attendee: info.name,
          phone: info.phone,
          validCode: '',
          company: info.company,
          carNumber: '',
          faceImg: ''
        };
        this.personalInfo = info;
      }
      this.getInfo();
    }
  },
  mounted() {
    if (!this.$route.query.view) {
      const personalInfo = localStorage.getItem('personalInfo');
      if (personalInfo) {
        const info = JSON.parse(personalInfo);
        if (info.phone) {
          this.$refs[this.pageStyle].showSms = false;
        }
      }
      // this.getInfo();
    }
    window.scrollTo(0, 0);
  },
  methods: {
    getInfo() {
      meetingInvitation({ meetingId: this.$route.query.id }).then(res => {
        this.meetingInfo = res.data;
        if (res.data.apply) {
          if (res.data.visitorLogId > 0) {
            this.getVisitPassCode(res.data.visitorLogId);
          } else {
            this.getStaffPassCode();
          }
        }
        const { agendas, materials } = res.data;
        this.meetingInfo.materials = materials;
        this.meetingInfo.agendasList = agendas;
        // agendas && agendas.forEach((item, index) => {
        //   if (index % 2 !== 0) {
        //     this.meetingInfo.agendasList.push(item);
        //     if (index !== agendas.length - 1) {
        //       this.meetingInfo.agendasList.push('');
        //       this.meetingInfo.agendasList.push('');
        //     } else {
        //       this.meetingInfo.agendasList.push('');
        //     }
        //   } else {
        //     this.meetingInfo.agendasList.push(item);
        //   }
        // });
        this.meetingInfo.infoList = [
          { name: '会议时间', value: `${res.data.startTime} ~ ${res.data.endTime}` },
          { name: '会议地点', value: `${res.data.meetingRoomName}` },
          { name: '签到规则', value: `${res.data.signTypeName}` },
          { name: '签到时间', value: `会议前${res.data.signTime}分钟开始签到` }
          // { name: '会议资料', value: 'AI科技发布会新品抢先看.zip' }
        ];
      });
    },
    getVisitPassCode(id) {
      GetVisitorAppoinDetail({ id }).then(res => {
        let auth = '';
        res.data.authTypes && res.data.authTypes.forEach((item, index) => {
          if (index === res.data.authTypes.length - 1) {
            auth += this.statusMap[item];
          } else {
            auth += `${this.statusMap[item]}、`;
          }
        });
        if (res.data.faceImg) {
          this.uploadSuc = true;
        }
        res.data.authName = auth;
        res.data.qrCodeImgUrl = `${this.baseURL}/wechat/qr/create?content=${encodeURIComponent(res.data.qrCode)}&timestamp=${new Date().getTime()}`;
        this.passInfo = res.data;
      });
    },
    getStaffPassCode() {
      GetStaffInfo({}).then(res => {
        const { qr, faceImg } = res.data;
        res.data.qrCode = res.data.qr;
        if (!qr && !faceImg) { // 都没有的时候就上传人脸
          res.data.authName = '';
        } else if (qr && !faceImg) {
          res.data.authName = '二维码';
          res.data.qrCodeImgUrl = `${this.baseURL}/wechat/qr/create?content=${encodeURIComponent(qr)}&timestamp=${new Date().getTime()}`;
        } else if (!qr && faceImg) {
          this.uploadSuc = true;
          res.data.authName = '人脸';
        } else if (qr && faceImg) {
          this.uploadSuc = true;
          res.data.authName = '二维码、人脸';
          res.data.qrCodeImgUrl = `${this.baseURL}/wechat/qr/create?content=${encodeURIComponent(qr)}&timestamp=${new Date().getTime()}`;
        }
        this.passInfo = res.data;
      });
    },
    meetingApply(data) {
      data.meetingId = this.meetingInfo.id;
      if (this.login) { // 登录了
        if (this.personalInfo.phone !== data.phone && !data.validCode) {
          this.$toast({
            message: '请输入验证码'
          });
        }
        inviteApply(data).then(res => {
          if (res.code === 200) {
            if (res.data.personType !== 'STAFF') {
              // this.$toast.loading({
              //   message: '生成中...',
              //   forbidClick: true,
              //   loadingType: 'spinner',
              //   duration: 0
              // });
              this.timer = window.setInterval(() => {
                setTimeout(() => {
                  this.getVisitorCheck(res.data.visitorLogId);
                }, 0);
              }, 1000);
            } else {
              this.getInfo();
            }
          }
        });
      } else {
        this.onLogin(data);
      }
    },
    onLogin(data) {
      data.name = data.attendee;
      data.smsCode = data.validCode;
      data.validCode = '';
      onBind(data).then(res => {
        if (res.code === 200) {
          GetUserInfo(data).then(response => {
            if (response.data) {
              localStorage.setItem('personalInfo', JSON.stringify(data));
            }
          });
          inviteApply(data).then(res => {
            if (res.code === 200) {
              if (res.data.personType !== 'STAFF') {
                // this.$toast.loading({
                //   message: '生成中...',
                //   forbidClick: true,
                //   loadingType: 'spinner',
                //   duration: 0
                // });
                this.timer = window.setInterval(() => {
                  setTimeout(() => {
                    this.getVisitorCheck(res.data.visitorLogId);
                  }, 0);
                }, 1000);
              } else {
                this.getInfo();
              }
            }
            this.$toast({
              message: '报名成功'
            });
          });
        }
      }).catch(err => {
        console.log(err);
      });
    },
    getVisitorCheck(id) {
      visitorCheck({ id }).then(res => {
        if (res.code === 200) {
          if (res.data) {
            // this.meetingInfo.visitorLogId = id;
            window.clearInterval(this.timer);
            this.getInfo();
            this.getVisitPassCode(id);
            this.$toast.clear();
          }
        } else {
          window.clearInterval(this.timer);
        }
      });
    },
    onSign() {
      meetingSignIn({ id: this.meetingInfo.id }).then(response => {
        if (response.code === 200) {
          this.$toast.success('签到成功');
          setTimeout(() => {
            // this.meetingInfo.signIn = true;
            this.getInfo();
          }, 500);
        } else {
          this.$toast.fail(response.message);
        }
      });
    },
    onCancel() {
      this.showCancelDialog = true;
    },
    confirmCancel() {
      const data = {
        id: this.meetingInfo.id,
        remake: this.message
      };
      meetingAttendeeCancel(data).then(res => {
        this.$toast.success('取消成功');
        this.getInfo();
      });
    },
    refreshQrCode() {
      this.passInfo.qrCodeImgUrl = `${this.baseURL}/wechat/qr/create?content=${encodeURIComponent(this.passInfo.qrCode)}&timestamp=${new Date().getTime()}`;
    },
    refreshUploadSuc(val) {
      this.uploadSuc = val;
    },
    goBack() {
      this.$router.push({ name: 'user' });
    },
    goBackMeeting() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less">
.change_val(@name, @px){
    @{name}: @px / 200.6 * 1rem;
}
.change_margin(@name, @top, @right){
    @{name}: @top / 200.6 * 1rem @right / 200.6 * 1rem;
}
.invitations {
  height: 100%;
  max-width: 100%;
  .control {
    .van-field__control{
      text-align: left;
    }
  }
}
</style>
